import * as types from './actionTypes';

export function setAccountNumberId(lockedId) {
  return {
    type: types.SET_ACCOUNTNUMBER_LOCK,
    lockedId,
  };
}

export function unLockAccountNumber(locked) {
  return {
    type: types.SET_UNSET_LOCK,
    locked,
  };
}
